export default "/static/webpack/fonts/nickainley-normal-webfont.woff";